import { updateAllQueries } from 'api/urql/helpers/mutation';
import { query } from 'components/pages/import/queries/getImportedDrafts';

export const submitMofo = (results, args, cache, info) => {
  // handlers go here
  updateAllQueries({
    fieldName: 'submitMofo',
    query,
  })(results, args, cache, info);
};
